import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientFileEntity } from './client-file.entity';
import { ClientRegistrationNewFileEntity } from './client-registration-new-file.entity';
import { CompetitivePriceFileEntity } from './competitive-price-file.entity';
import { ImportExportEntity } from './import-export.entity';
import { InvoiceFileEntity } from './invoice-file.entity';
import { IssueFileEntity } from './issue-file.entity';
import { ItemFileEntity } from './item-file.entity';
import { ItemImageEntity } from './item-image.entity';
import { LicenseFileEntity } from './license-file.entity';
import { MPaymentTransactionEntity } from './m-payment-transaction.entity';
import { NotificationFileEntity } from './notification-file.entity';
import { OpportunityFileEntity } from './opportunity-file.entity';
import { OrderFileEntity } from './order-file.entity';
import { PurchaseOrderFileEntity } from './purchase-order-file.entity';
import { SourcingRequestFileEntity } from './sourcing-request-file.entity';

@Entity('_file')
export class FileEntity extends BaseEntity {
	@Column('varchar', { name: '_key', length: 64 })
	public key!: string;

	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('varchar', { name: '_contentType', nullable: true, length: 255 })
	public contentType!: string | null;

	@Column('varchar', { name: '_mimetype', nullable: true, length: 128 })
	public mimetype!: string | null;

	@Column('varchar', { name: '_description', nullable: true, length: 255 })
	public description!: string | null;

	@Column('varchar', { name: '_type', nullable: true, length: 50 })
	public type!: string | null;

	@Column('varchar', { name: '_subtype', nullable: true, length: 50 })
	public subtype!: string | null;

	@Column('tinyint', { name: '_is_public', width: 1 })
	public isPublic!: boolean;

	@Column('tinyint', { name: '_hasPreview', nullable: true, width: 1 })
	public hasPreview!: boolean | null;

	@OneToMany(
		() => ImportExportEntity,
		(importExport) => importExport.fkFile,
		{},
	)
	importExports!: Array<ImportExportEntity>;

	@OneToMany(
		() => NotificationFileEntity,
		(notificationFile) => notificationFile.fkFile,
		{},
	)
	public notificationFiles!: Array<NotificationFileEntity>;

	@OneToMany(() => ClientFileEntity, (clientFile) => clientFile.fkFile, {})
	public clientFiles!: Array<ClientFileEntity>;

	@OneToMany(
		() => ClientRegistrationNewFileEntity,
		(clientRegistrationNewFile) => clientRegistrationNewFile.fkFile,
		{},
	)
	public clientRegistrationNewFiles!: Array<ClientRegistrationNewFileEntity>;

	@OneToMany(
		() => CompetitivePriceFileEntity,
		(competitivePriceFile) => competitivePriceFile.fkFile,
		{},
	)
	public competitivePriceFiles!: Array<CompetitivePriceFileEntity>;

	@OneToMany(() => InvoiceFileEntity, (invoiceFile) => invoiceFile.fkFile, {})
	public invoiceFiles!: Array<InvoiceFileEntity>;

	@OneToMany(() => ItemFileEntity, (itemFile) => itemFile.fkFile, {})
	public itemFiles!: Array<ItemFileEntity>;

	@OneToMany(() => ItemImageEntity, (itemImage) => itemImage.fkFile, {})
	public itemImages!: Array<ItemImageEntity>;

	@OneToMany(
		() => MPaymentTransactionEntity,
		(mPaymentTransaction) => mPaymentTransaction.mPaymentFkFileIdSignature2,
		{},
	)
	public mPaymentTransactions!: Array<MPaymentTransactionEntity>;

	@OneToMany(() => OrderFileEntity, (orderFile) => orderFile.fkFile, {})
	public orderFiles!: Array<OrderFileEntity>;

	@OneToMany(
		() => PurchaseOrderFileEntity,
		(purchaseOrderFile) => purchaseOrderFile.fkFile,
		{},
	)
	public purchaseOrderFiles!: Array<PurchaseOrderFileEntity>;

	@OneToMany(() => LicenseFileEntity, (licenseFile) => licenseFile.fkFile, {})
	public licenseFiles!: Array<LicenseFileEntity>;

	@OneToMany(() => IssueFileEntity, (issueFile) => issueFile.fkFile, {})
	public issueFiles!: Array<IssueFileEntity>;

	@OneToMany(
		() => SourcingRequestFileEntity,
		(sourcingRequestFile) => sourcingRequestFile.fkFile,
		{},
	)
	public sourcingRequestFiles!: Array<SourcingRequestFileEntity>;

	@OneToMany(
		() => OpportunityFileEntity,
		(opportunityFile) => opportunityFile.fkFile,
		{},
	)
	public opportunityFiles!: Array<OpportunityFileEntity>;
}
